export default {
    appId:  'JQo7DfERd0wCOw12uHh5Gkr6-gzGzoHsz',
    appKey: '8JrBiMynrOxOGhW0zpvaHOnt'
}